import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage as FM } from 'react-intl';
import { required } from 'redux-form-validators';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';

import { DefaultButton, ReduxSelectField, ReduxTextField, TextAreaField } from 'common/components';
import { stripRtlWordMarks, reverseWordsKeepWhitespaceByLines } from 'common/utils';

import staticStyles from './style';

import { createTemplate } from '../../_redux';

const CreateTemplateForm = ({ languages, language, submitting, invalid, handleSubmit, dispatch, history, error }) => {
  const isArabic = language === 'ar';

  // ar 模板：表单里按逻辑序（输入顺序）编辑，提交时转成阿语展示序入库，后端可直接取出使用；
  // 其他语言原样入库。均先剥离历史数据里可能残留的方向标记。
  const submit = handleSubmit(({ title, text, ...rest }) => {
    const cleanTitle = stripRtlWordMarks(title);
    const cleanText = stripRtlWordMarks(text);
    return createTemplate(
      {
        ...rest,
        title: isArabic ? reverseWordsKeepWhitespaceByLines(cleanTitle) : cleanTitle,
        text: isArabic ? reverseWordsKeepWhitespaceByLines(cleanText) : cleanText,
      },
      dispatch
    );
  });

  // 任何语言选择（含首次）都重置标题与正文，保证字段内容与当前语言一致。
  const handleLanguageChange = () => {
    dispatch(change('CreateTemplateForm', 'title', ''));
    dispatch(change('CreateTemplateForm', 'text', ''));
  };

  return (
    <form className="CreateTemplateForm" onSubmit={submit}>
      <Field
        component={ReduxSelectField}
        name="language"
        maxMenuHeight={100}
        textId="justLanguage"
        options={languages}
        validate={[required()]}
        disabled={submitting}
        onChange={handleLanguageChange}
      />
      <span className="CreateTemplateForm__langHint">
        <FM id="formTemplatesSwitchLanguageHint" />
      </span>
      <Field
        component={ReduxTextField}
        name="title"
        textId="formTemplatesTitle"
        validate={[required()]}
        rtlWords={isArabic}
      />
      <Field
        component={TextAreaField}
        name="text"
        textId="justText"
        rows="16"
        cols="150"
        validate={[required()]}
        disabled={submitting}
        rtlWords={isArabic}
      />
      {error && <strong className="formError">{error}</strong>}
      <div className="CreateTemplateForm__btns">
        <DefaultButton textId="doSave" type="submit" loading={submitting} disabled={invalid || submitting} filled />
        <DefaultButton
          textId="justCancel"
          type="button"
          loading={submitting}
          disabled={submitting}
          onClick={() => history.push('/backoffice/templates')}
        />
      </div>
      <style jsx>{staticStyles}</style>
    </form>
  );
};

CreateTemplateForm.propTypes = {
  languages: PropTypes.array,
  language: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  error: PropTypes.string,
};

CreateTemplateForm.defaultProps = {
  error: '',
  languages: [],
  language: '',
};

export default compose(
  reduxForm({
    form: 'CreateTemplateForm',
    onSubmitSuccess: (result, dispatch, props) => {
      props.history.push('/backoffice/templates');
    },
  }),
  connect(state => ({
    language: formValueSelector('CreateTemplateForm')(state, 'language'),
  }))
)(CreateTemplateForm);
